import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";

import Header from "../../components/layout/Header";
import Menu from "../../components/layout/Menu";
import Content from "../../components/layout/Page/Content";
import ContentDocuments from "../../components/layout/Page/Documents";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
}));

export default function Documents() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header />
      <Menu />
      <Content>
        <Breadcrumbs aria-label="breadcrumb">
          <Link style={{ textDecoration: "none", color: "inherit" }} to="/home">
            Dashboard
          </Link>
          <Typography color="textPrimary">Documentos</Typography>
        </Breadcrumbs>
        <ContentDocuments />
      </Content>
    </div>
  );
}
